import React, { ReactNode } from 'react';
import styles from './styles.module.css';
import PageWrapper from '@/components/general/PageWrapper';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import MainIcons from '@/icons/main';
import { Features } from '@/components/pages/home/HomeContent/Features/Features';
import { avatarBg, avatarBgGlow } from '@/functions/formats';
import ServiceQA from './ServiceQA';
import BannerCta from '@/components/general/BannerCta';
import ServiceBanner from './ServiceBanner';
import SampleBlogs from '@/components/pages/home/HomeContent/SampleBlogs';

export default function ServiceLayout({
  children,
  bannerText,
  bannerTitle,
}: {
  children?: ReactNode;
  bannerText?: string;
  bannerTitle?: string;
}) {
  const manageFeat = {
    kicker: 'چطور کار می‌کند',
    title: 'مدیریت پلاک‌ها در سه گام',
    cards: [
      {
        icon: <MainIcons.plusIcon />,
        t: 'افزودن پلاک',
        d: 'شمارهٔ پلاک هر خودرو را یک‌بار ثبت کنید تا برای همیشه در حساب شما بماند.',
        bg: avatarBg(0),
        glow: avatarBgGlow(0),
      },
      {
        icon: <MainIcons.documentIcon />,
        t: 'مشاهدهٔ وضعیت',
        d: 'خلافی، نمرهٔ منفی گواهینامه و وضعیت گذرنامهٔ همهٔ پلاک‌ها را یکجا ببینید.',
        bg: avatarBg(1),
        glow: avatarBgGlow(1),
      },
      {
        icon: <MainIcons.LockIcon />,
        t: 'پرداخت یکجا',
        d: 'بدهی همهٔ پلاک‌ها را با کیف پول یا درگاه بانکی، در یک پرداخت تسویه کنید.',
        bg: avatarBg(2),
        glow: avatarBgGlow(2),
      },
    ],
  };
  const whyFeat = {
    kicker: 'چرا کارا',
    title: 'مدیریت یکپارچهٔ همهٔ خودروها',
    text: 'به‌جای استعلام جداگانهٔ هر پلاک، همهٔ خودروهای خود را در یک داشبورد امن کنترل کنید.',
    cards: [
      {
        icon: <MainIcons.carIcon />,
        t: 'همهٔ خودروها یکجا',
        d: 'پلاک‌های خانواده یا ناوگان خود را در یک حساب ثبت و مدیریت کنید.',
        bg: avatarBg(0),
        glow: avatarBgGlow(0),
      },
      {
        icon: <MainIcons.BellIcon />,
        t: 'اطلاع‌رسانی خودکار',
        d: 'به‌محض ثبت خلافی جدید روی هر پلاک، پیامک و اعلان دریافت می‌کنید.',
        bg: avatarBg(1),
        glow: avatarBgGlow(1),
      },
      {
        icon: <MainIcons.lightIcon />,
        t: 'تحلیل هوشمند هزینه',
        d: 'کارا بدهی هر پلاک را تحلیل و پرهزینه‌ترین خودرو را به شما نشان می‌دهد.',
        bg: avatarBg(2),
        glow: avatarBgGlow(2),
      },
    ],
  };
  return (
    <>
      {children}
      <PageWrapper className="mt-0 section-paper mb-4px p-0">
        <ViewportWrapper className={`container `}>
          <Features feat={manageFeat} cardBg="lightGray" showNumber={true} />
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className="mt-0 section-light  mb-4px p-0">
        <ViewportWrapper className={`container`}>
          <Features feat={whyFeat} />
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className="mt-0 section-paper  mb-4px p-0">
        <ViewportWrapper className={`container py-0`}>
          <ServiceQA />
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className="mt-0 section-paper  mb-4px p-0">
        <ViewportWrapper className={`container ${styles.banner}`}>
          <ServiceBanner title={bannerTitle} text={bannerText} />
        </ViewportWrapper>
      </PageWrapper>

      <PageWrapper className={`w-full mt-0`} style={{ backgroundColor: 'var(--paper)' }}>
        <ViewportWrapper className={`container py-0`}>
          <SampleBlogs />
        </ViewportWrapper>
      </PageWrapper>
    </>
  );
}
